const { BASE_URL } = require("./client");

const GET_PASSWORDS = BASE_URL + "/api/admin/password/get";
const SET_PASSOWORD = BASE_URL + "/api/admin/password/set";
const DELETE_PASSWORD = BASE_URL + "/api/admin/password/delete/";

export { GET_PASSWORDS, SET_PASSOWORD, DELETE_PASSWORD };
